import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  customerIdSelector,
  pbxIdSelector,
  tenantIdSelector,
} from "@/react/features/customer/customerSlice";
import { userSelector } from "@/react/store/userSlice";

import { initO11y, updateO11yUserData } from "./o11y";

export const O11yHub = () => {
  const user = useSelector(userSelector);
  const customerId = useSelector(customerIdSelector);
  const pbxId = useSelector(pbxIdSelector);
  const tenantId = useSelector(tenantIdSelector);
  const [o11yInitialized, setO11yInitialized] = useState(false);

  useEffect(() => {
    if (user && !isEmpty(user) && !o11yInitialized) {
      initO11y()
        .then(() => setO11yInitialized(true))
        .catch((e) => console.log("Error initializing observability", e));
    }
  }, [user, o11yInitialized]);

  useEffect(() => {
    if (o11yInitialized) {
      updateO11yUserData({
        user,
        attributes: {
          customerId,
          pbxId,
          tenantId,
        },
      });
    }
  }, [o11yInitialized, user?.email, customerId, pbxId, tenantId]);

  return <></>;
};
